import { createAsyncThunk } from '@reduxjs/toolkit';
import { dmProjectsService } from '../../../services/designManagement/dmProjects.services';
import { showHideLoader } from '../../common/common.slice';


// Get projects list action
// change-req 
const getProjectsListAction = createAsyncThunk('dmProjectsSlice/getProjectsListAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    // dispatch(showHideLoader(true));

    const { salesProjects: { projectDetails } } = await getState() as any;

    return dmProjectsService.getProjectListService({
        ...payload,
        designer_id: projectDetails?.designer?.id?? payload?.id
    })
        .then((response) => {
            // dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            // dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Get project center invoices list action
// change-req 
const getProjectInvoicesListAction = createAsyncThunk('dmProjectsSlice/getProjectInvoicesListAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }

    const { salesProjects: { projectDetails } } = await getState() as any;

    return dmProjectsService.getProjectInvoicesListService({
        ...payload,
        designer_id: projectDetails?.designer?.id?? payload?.id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Get project center invoice details action
// change-req 
const getProjectInvoiceDetailsAction = createAsyncThunk('dmProjectsSlice/getProjectInvoiceDetailsAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));

    const { salesProjects: { projectDetails } } = await getState() as any;

    return dmProjectsService.getProjectInvoiceDetailsService({
        ...payload,
        designer_id: projectDetails?.designer?.id?? payload?.id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});


// modify invoice action
const updateInvoiceAction = createAsyncThunk('fmProjectsSlice/updateInvoiceAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    // dispatch(showHideLoader(true));
    
    const { login: { userObject } } = await getState() as any;

    return dmProjectsService.updateInvoiceService({
        ...payload,
        designer_id: userObject?.id
    })
        .then((response) => {
            // dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            // dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Release project center invoice action
// change-req 
const releaseInvoicesAction = createAsyncThunk('dmProjectsSlice/releaseInvoicesAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));
    
    const { salesProjects: { projectDetails } } = await getState() as any;

    return dmProjectsService.releaseInvoiceService({
        ...payload,
        designer_id: projectDetails?.designer?.id?? payload?.id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Upload project center invoice action
const uploadPdfForInvoiceAction = createAsyncThunk('dmProjectsSlice/uploadPdfForInvoiceAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));
    return dmProjectsService.uploadPdfForInvoiceService(payload)
    .then((response) => {
      setTimeout(() => {
          dispatch(showHideLoader(false))
        }, 500)
      return response
    })
    .catch((error: { response: unknown; }) => {
      setTimeout(() => {
          dispatch(showHideLoader(false))
        }, 500)
      return rejectWithValue(error?.response)
    })
});

// Upload project center change order action
const uploadPdfForChangeOrderAction = createAsyncThunk('dmProjectsSlice/uploadPdfForChangeOrderAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));
    return dmProjectsService.uploadPdfForChangeOrderService(payload)
    .then((response) => {
      setTimeout(() => {
          dispatch(showHideLoader(false))
        }, 500)
      return response
    })
    .catch((error: { response: unknown; }) => {
      setTimeout(() => {
          dispatch(showHideLoader(false))
        }, 500)
      return rejectWithValue(error?.response)
    })
});

// Get project overview details action
// change-req 
const getProjectOverviewDetailsAction = createAsyncThunk('dmProjectsSlice/getProjectOverviewDetailsAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }

    const { salesProjects: { projectDetails } } = await getState() as any;

    return dmProjectsService.projectOverviewDetailsService({
        ...payload,
        designer_id: projectDetails?.designer?.id?? payload?.id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Get project timeline task-list action
// change-req 
const getProjectTimelineListAction = createAsyncThunk('dmProjectsSlice/getProjectTimelineListAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }

    const { salesProjects: { projectDetails } } = await getState() as any;

    return dmProjectsService.getProjectTimelineListService({
        ...payload,
        pmId: projectDetails?.designer?.id?? payload?.id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Update project task connections action
// change-req
const updateTaskConnectionAction = createAsyncThunk('dmProjectsSlice/updateTaskConnectionAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }
    
    const { salesProjects: { projectDetails } } = await getState() as any;

    return dmProjectsService.updateTaskConnectionsService({
        ...payload,
        pmId: projectDetails?.designer?.id?? payload?.id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Get project phase tasks list action
// change-req
const getProjectTasksListAction = createAsyncThunk('dmProjectsSlice/getProjectTasksListAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }

    const { salesProjects: { projectDetails } } = await getState() as any;

    return dmProjectsService.getProjectTasksService({
        ...payload,
        pmId: projectDetails?.designer?.id?? payload?.id
    })
        // response is being altered in the slice
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Get project overview task details action
// change-req
const getProjectOverviewTaskDetailsAction = createAsyncThunk('dmProjectsSlice/getProjectOverviewTaskDetailsAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }

    const { salesProjects: { projectDetails } } = await getState() as any;

    return dmProjectsService.projectOverviewTaskDetailsService({
        ...payload,
        pmId: projectDetails?.designer?.id?? payload?.id
    })
        .then((response) => {
            setTimeout(() => {
                dispatch(showHideLoader(false))
            }, 500)
            return response;
        })
        .catch((error: {response: unknown;}) => {
            setTimeout(() => {
                dispatch(showHideLoader(false))
            }, 500)
            return rejectWithValue(error?.response);
        });
});

// Get project milestones action
const getProjectMilestonesAction = createAsyncThunk('dmProjectsSlice/getProjectMilestonesAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));

    return dmProjectsService.projectMilestonesService({
        ...payload,
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Get project phases action
// change-req
const getProjectPhasesAction = createAsyncThunk('dmProjectsSlice/getProjectPhasesAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));

    const { salesProjects: { projectDetails } } = await getState() as any;

    return dmProjectsService.getProjectPhasesList({
        ...payload,
        pmId: projectDetails?.designer?.id?? payload?.id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Add project task action
// change-req
const addProjectTaskAction = createAsyncThunk('dmProjectsSlice/addProjectTaskAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));

    const { salesProjects: { projectDetails } } = await getState() as any;

    return dmProjectsService.addProjectTaskService({
        ...payload,
        pmId: projectDetails?.designer?.id?? payload?.id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Update project task action
// change-req 
const updateProjectTaskAction = createAsyncThunk('dmProjectsSlice/updateProjectTaskAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }

    const { salesProjects: { projectDetails } } = await getState() as any;

    return dmProjectsService.updateProjectTaskService({
        ...payload,
        pmId: projectDetails?.designer?.id?? payload?.id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Delete project task action
// change-req
const deleteProjectTaskAction = createAsyncThunk('dmProjectsSlice/deleteeProjectTaskAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));

    const { salesProjects: { projectDetails } } = await getState() as any;

    return dmProjectsService.deleteProjectTaskService({
        ...payload,
        pmId: projectDetails?.designer?.id?? payload?.id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Inline update project task action
// change-req 
const inlineUpdateProjectTaskAction = createAsyncThunk('dmProjectsSlice/inlineUpdateProjectTaskAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }

    const { salesProjects: { projectDetails } } = await getState() as any;

    return dmProjectsService.inlineUpdateProjectTaskService({
        ...payload,
        pmId: projectDetails?.designer?.id?? payload?.id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// get change order Action
const getChangeOrderAction = createAsyncThunk(
    'dmProjectsSlice/getChangeOrderAction', (payload: any, { dispatch, rejectWithValue }) => {
      dispatch(showHideLoader(true));
      return dmProjectsService.getChangeOrderService(payload)
        .then((response) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return response
        })
        .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
        })
    }
  );

// get change order items Action
const getChangeOrderItemsAction = createAsyncThunk(
    'dmProjectsSlice/getChangeOrderItemsAction', (payload: any, { dispatch, rejectWithValue }) => {
        //   dispatch(showHideLoader(true));
        return dmProjectsService.getChangeOrderItemsService(payload)
            .then((response) => {
                //   setTimeout(() => {
                //     dispatch(showHideLoader(false))
                //   }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                //   setTimeout(() => {
                //     dispatch(showHideLoader(false))
                //   }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// create change order Action
const createChangeOrderAction = createAsyncThunk(
    'dmProjectsSlice/createChangeOrderAction', (dealId: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.createChangeOrderService(dealId)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// create change order Action
const saveChangeOrderAction = createAsyncThunk(
    'dmProjectsSlice/saveChangeOrderAction', ({change_order_id, payload, persistLoader}:any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.saveChangeOrderService(change_order_id, payload)
            .then((response) => {
                if(!persistLoader){
                    setTimeout(() => {
                        dispatch(showHideLoader(false))
                    }, 500)
                }
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// create change order Action
const getChangeOrderDetailsAction = createAsyncThunk(
    'dmProjectsSlice/getChangeOrderDetailsAction', (change_order_id: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.getChangeOrderDetailsService(change_order_id)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// get change order terms Action
const getChangeOrderTermsAction = createAsyncThunk(
    'dmProjectsSlice/getChangeOrderTermsAction', (change_order_id: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.getChangeOrderTermsService(change_order_id)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);


// save change order notes Action
const saveChangeOrderNotesAction = createAsyncThunk(
    'dmProjectsSlice/saveChangeOrderNotesAction', ({change_order_id,payload}: any, { dispatch, rejectWithValue }) => {
        // dispatch(showHideLoader(true));
        return dmProjectsService.saveChangeOrderNotesService(change_order_id,payload)
            .then((response) => {
                setTimeout(() => {
                    // dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    // dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// save change order Intro Action
const saveChangeOrderIntroAction = createAsyncThunk(
    'dmProjectsSlice/saveChangeOrderIntroAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.saveChangeOrderIntroService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// upload change order pdf Action
const uploadChangeOrderPdfAction = createAsyncThunk(
    'dmProjectsSlice/uploadChangeOrderPdfAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.uploadChangeOrderPdfService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// upload change order pdf Action
const changeOrderAttachmentListAction = createAsyncThunk(
    'dmProjectsSlice/changeOrderAttachmentListAction', (change_order_id: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.changeOrderAttachmentListService(change_order_id)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// upload change order pdf Action
const removeChangeOrderAttachmentAction = createAsyncThunk(
    'dmProjectsSlice/removeChangeOrderAttachmentAction', (attachmentId: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.removeChangeOrderAttachmentService(attachmentId)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// upload change order pdf Action
const exportChangeOrderAction = createAsyncThunk(
    'dmProjectsSlice/exportChangeOrderAction', ({change_order_id,payload}: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.exportChangeOrderService(change_order_id,payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// delete change order Action
const deleteChangeOrderAction = createAsyncThunk(
    'dmProjectsSlice/deleteChangeOrderAction', (change_order_id: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.deleteChangeOrderService(change_order_id)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// duplicate change order Action
const duplicateChangeOrderAction = createAsyncThunk(
    'dmProjectsSlice/duplicateChangeOrderAction', (change_order_id: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.duplicateChangeOrderService(change_order_id)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// get co payment schedule Action
const getCOPaymentScheduleAction = createAsyncThunk(
    'dmProjectsSlice/getCOPaymentScheduleAction', (change_order_id: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.getCOPaymentScheduleService(change_order_id)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// get co payment schedule Action
const updateCOPaymentScheduleAction = createAsyncThunk(
    'dmProjectsSlice/updateCOPaymentScheduleAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.updateCOPaymentScheduleService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// Rfp List Action
const rfpListAction = createAsyncThunk(
    'dmProjectsSlice/rfpListAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.rfpListService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// Create Rfp Action
const createRfpAction = createAsyncThunk(
    'dmProjectsSlice/createRfpAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.createRfpService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// Update Rfp Action
const updateRfpAction = createAsyncThunk(
    'dmProjectsSlice/updateRfpAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.updateRfpService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// Unrelease change order Action
const unreleaseChangeOrderAction = createAsyncThunk(
    'dmProjectsSlice/unreleaseChangeOrderAction', (change_orde_id: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return dmProjectsService.unreleaseChangeOrder(change_orde_id)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// rearrange overview list Action
// change-req 
const rearrangeOverviewListAction = createAsyncThunk(
    'dmProjectsSlice/rearrangeOverviewListAction', async(payload: any, { getState, dispatch, rejectWithValue }) => {
        // dispatch(showHideLoader(true));

        const { salesProjects: { projectDetails } } = await getState() as any;

        return dmProjectsService.rearrangeProjectOverviewDetailsService({
            ...payload,
            userId: projectDetails?.designer?.id?? payload?.id
        })
            .then((response) => {
                setTimeout(() => {
                    // dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// generate zip Action
const generateZipAction = createAsyncThunk(
    'dmProjectsSlice/generateZipAction', (payload: any, { dispatch, rejectWithValue }) => {
        // dispatch(showHideLoader(true));
        return dmProjectsService.generateZip(payload)
            .then((response) => {
                setTimeout(() => {
                    // dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);


// Export all Projects Action
export const dmProjectsAction = {
    getProjectsListAction,
    getProjectInvoicesListAction,
    getProjectInvoiceDetailsAction,
    updateInvoiceAction,
    releaseInvoicesAction,
    uploadPdfForInvoiceAction,
    uploadPdfForChangeOrderAction,
    getProjectOverviewDetailsAction,
    getProjectTimelineListAction,
    updateTaskConnectionAction,
    getProjectTasksListAction,
    getProjectOverviewTaskDetailsAction,
    getProjectMilestonesAction,
    getProjectPhasesAction,
    addProjectTaskAction,
    updateProjectTaskAction,
    deleteProjectTaskAction,
    inlineUpdateProjectTaskAction,
    getChangeOrderAction,
    getChangeOrderItemsAction,
    createChangeOrderAction,
    saveChangeOrderAction,
    getChangeOrderDetailsAction,
    getChangeOrderTermsAction,
    saveChangeOrderNotesAction,
    saveChangeOrderIntroAction,
    uploadChangeOrderPdfAction,
    changeOrderAttachmentListAction,
    removeChangeOrderAttachmentAction,
    exportChangeOrderAction,
    deleteChangeOrderAction,
    duplicateChangeOrderAction,
    getCOPaymentScheduleAction,
    updateCOPaymentScheduleAction,
    rfpListAction,
    createRfpAction,
    updateRfpAction,
    unreleaseChangeOrderAction,
    rearrangeOverviewListAction,
    generateZipAction
}